
import { Difficulty, Joker, TileType } from './types';

export const INITIAL_FOCUS = 6; 
export const MAX_JOKERS = 5;
export const TOTAL_STAGES = 5;

export const STAGE_CONFIGS: Record<Difficulty, { target: number, diff: Difficulty, twist: string }[]> = {
  EASY: [
    { target: 200, diff: 'EASY', twist: "Warm-up phase" },
    { target: 500, diff: 'EASY', twist: "Golden Influx (+Tiles)" },
    { target: 1000, diff: 'EASY', twist: "Focus Surge (+1 Max Focus)" },
    { target: 1800, diff: 'EASY', twist: "The Calm Before..." },
    { target: 3000, diff: 'MEDIUM', twist: "BOSS: Double Stakes (No recovery)" },
  ],
  MEDIUM: [
    { target: 600, diff: 'EASY', twist: "Standard Operations" },
    { target: 1500, diff: 'MEDIUM', twist: "The Grind" },
    { target: 3000, diff: 'MEDIUM', twist: "High Friction" },
    { target: 5500, diff: 'HARD', twist: "Logic Exhaustion" },
    { target: 8500, diff: 'HARD', twist: "BOSS: System Overload" },
  ],
  HARD: [
    { target: 1200, diff: 'MEDIUM', twist: "Trial by Fire" },
    { target: 3000, diff: 'HARD', twist: "The Wall" },
    { target: 6000, diff: 'HARD', twist: "Entropy Rising" },
    { target: 10000, diff: 'HARD', twist: "Data Corruption" },
    { target: 15000, diff: 'HARD', twist: "BOSS: The Singularity" },
  ]
};

export const STARTER_JOKERS: Joker[] = [
  { id: 'j_1', name: 'Second Chance', description: 'Passive: First mistake per stage costs 0 Focus.', rarity: 'Common', cost: 4, type: 'PASSIVE' },
  { id: 'j_2', name: 'Hot Hand', description: 'Passive: 3 streak -> next tile gives double score.', rarity: 'Common', cost: 5, type: 'PASSIVE' },
  { id: 'j_3', name: 'Glass Brain', description: 'Passive: +50% score, but mistakes cost +1 extra damage.', rarity: 'Uncommon', cost: 7, type: 'PASSIVE' },
  { id: 'j_4', name: 'Meditation', description: 'Passive: Completing a 3x3 box restores +1 Focus.', rarity: 'Common', cost: 6, type: 'PASSIVE' },
  { id: 'j_5', name: 'Gambler\'s Insight', description: 'Passive: On mistake, reveal 1 random empty correct tile.', rarity: 'Uncommon', cost: 8, type: 'PASSIVE' },
  { id: 'j_6', name: 'Rule Bender', description: 'Active: Place any number ignoring rules once per stage.', rarity: 'Rare', cost: 10, type: 'ACTIVE', usesPerPuzzle: 1 },
  { id: 'j_7', name: 'Momentum', description: 'Passive: 5+ streak gives +5% score stacking per move.', rarity: 'Uncommon', cost: 8, type: 'PASSIVE' },
  { id: 'j_8', name: 'Emergency Focus', description: 'Passive: At 1 Focus, gain +2 (Once per stage).', rarity: 'Rare', cost: 11, type: 'PASSIVE' },
  { id: 'j_9', name: 'Sacrificial Play', description: 'Active: Kill tile for +250 Score & +1 Mult. Costs 1 Focus.', rarity: 'Rare', cost: 12, type: 'ACTIVE', usesPerPuzzle: 5 },
  { id: 'j_10', name: 'Clarity Shield', description: 'Passive: Every 6 correct placements grants 1 Shield.', rarity: 'Rare', cost: 10, type: 'PASSIVE' }
];

export const RARITY_COLORS = {
  Common: 'border-slate-500 shadow-slate-500/20 text-slate-300',
  Uncommon: 'border-emerald-500 shadow-emerald-500/20 text-emerald-300',
  Rare: 'border-purple-600 shadow-purple-600/30 text-purple-300',
  Legendary: 'border-orange-500 shadow-orange-500/40 text-orange-200'
};
